<template>
  <v-container id="paymentdone" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <base-material-card
          icon="mdi-card-text-outline"
          :title="
            payment_id
              ? $i18n.t('Edit Supplier Payment')
              : $i18n.t('Add Supplier Payment')
          "
          class="px-3 py-1 small-icon"
        >
          <v-btn
            style="position: absolute; right: 0px; top: -10px"
            x-small
            color="blue"
            v-if="payment_id && !singlePage"
            href="/paymentdone/create"
            >+ Add New</v-btn
          >
          <v-form id="form" v-model="isValid">
            <v-col>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding: 27px"
                  >
                    <v-row>
                      <v-col cols="12" sm="6" md="3" lg="2" v-if="!singlePage">
                        <z-entity-select
                          :label="$i18n.t('Servicing Entity')"
                          v-model="paymentdone.entity_id"
                          :rules="validationrules.entity_id"
                          corp="self"
                        ></z-entity-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="2" v-if="!singlePage">
                        <z-vendor-select
                          :label="$i18n.t('Service Provider')"
                          v-model="paymentdone.vendor_id"
                          :rules="validationrules.vendor_id"
                          :disabled="isEdit"
                        ></z-vendor-select>
                      </v-col>
                      <!-- <v-col cols="12" sm="12" md="6" lg="6" v-if="paymentdone.vendor_id == 'null'">
                        <v-text-field
                          :label="$i18n.t('Organization Name')"
                          v-model="paymentdone.organization.name"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" v-if="paymentdone.vendor_id == 'null'">
                        <v-text-field
                          :label="$i18n.t('Tax ID')"
                          v-model="paymentdone.organization.taxId"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" v-if="paymentdone.vendor_id == 'null'">
                        <v-text-field
                          :label="$i18n.t('Contact Name')"
                          v-model="paymentdone.organization.contact.name"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" v-if="paymentdone.vendor_id == 'null'">
                        <v-text-field
                          :label="$i18n.t('Contact Email')"
                          v-model="paymentdone.organization.contact.email"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" v-if="paymentdone.vendor_id == 'null'">
                        <z-country-select
                          isd
                          :label="$i18n.t('Country Code')"
                          v-model="paymentdone.organization.contact.countryCode"
                        ></z-country-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" v-if="paymentdone.vendor_id == 'null'">
                        <v-text-field
                          :label="$i18n.t('Contact Phone')"
                          v-model="paymentdone.organization.contact.phone"
                          type="number"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" v-if="paymentdone.vendor_id == 'null'">
                        <z-country-select
                          :label="$i18n.t('Country')"
                          v-model="paymentdone.organization.address.country"
                        ></z-country-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" v-if="paymentdone.vendor_id == 'null'">
                        <z-city-select
                          :label="$i18n.t('City')"
                          :country="paymentdone.organization.address.country"
                          v-model="paymentdone.organization.address.city"
                        ></z-city-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="12" v-if="paymentdone.vendor_id == 'null'">
                        <v-text-field
                          :label="$i18n.t('Address Line')"
                          v-model="paymentdone.organization.address.addressLine"
                        />
                      </v-col> -->

                      <v-col cols="12" sm="12" md="3" lg="2">
                        <z-date-picker
                          :label="$i18n.t('Date')"
                          v-model="paymentdone.date"
                          :rules="validationrules.date"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="3" lg="2">
                        <z-fund-account-select multiple="false" v-model="paymentdone.fundAC_id" :label="$i18n.t('Fund Account Select')" />
                      </v-col>

                      <v-col cols="12" sm="12" md="4" lg="2">
                        <v-text-field
                          :label="$i18n.t('Amount.')"
                          type="number"
                          @change="populateAmounts()"
                          v-model="paymentdone.totalAmount"
                          :rules="validationrules.totalAmount"
                        />
                      </v-col>

                      <v-col cols="12" sm="12" md="6" lg="2">
                        <!-- <v-autocomplete
                          :label="$i18n.t('Payment Mode')"
                          :items="paymentModes"
                          item-text="name"
                          item-value="name"
                          v-model="paymentdone.paymentMode"
                          :rules="validationrules.paymentMode"
                        /> -->
                        <z-name-master-select
                          v-model="paymentdone.paymentMode"
                          :type="7"
                          @click.native.stop
                          :label="$i18n.t('Payment Mode')"
                          :hideAddNew="true"
                        />
                      </v-col>

                      <v-col cols="12" sm="12" md="6" lg="2">
                        <v-text-field
                          :label="
                            paymentdone.paymentMode == 'CHEQUE'
                              ? $i18n.t('Cheque No')
                              : $i18n.t('Ref No')
                          "
                          v-model="paymentdone.refNo"
                          :rules="validationrules.refNo"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="2">
                        <v-select
                          v-model="paymentdone.paidTo"
                          type="number"
                          :label="$i18n.t('Paid To')"
                          :items="[
                            { name: 'Paid To Vendor', value: 1 },
                            { name: 'Paid To Driver', value: 2 },
                            { name: 'Paid To Agent', value: 3 },
                            { name: 'Paid to Truck Owner', value: 4 },
                            { name: 'Others', value: 5 },
                          ]"
                          item-text="name"
                          item-value="value"
                        />
                      </v-col>

                      <v-col  v-if="paymentdone.paymentMode == 'FUEL'">
<v-text-field
                          :label="$i18n.t('Fuel Outlet')"
                       
                          v-model="paymentdone.fuelOutlet"
                        />
</v-col>
                    </v-row>

                    <v-row
                      style="padding: 10px 10px"
                    
                    >
                      <v-col cols="12" md="4">
                        <v-text-field
                          :label="$i18n.t('Account Name')"
                          dense
                          v-model="paymentdone.bankAccount.holderName"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          :label="$i18n.t('Account Number')"
                          dense
                          v-model="paymentdone.bankAccount.accountNo"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          :label="$i18n.t('Bank Name')"
                          dense
                          v-model="paymentdone.bankAccount.bankName"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          :label="$i18n.t('IFSC Code')"
                          dense
                          v-model="paymentdone.bankAccount.ifsc"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          :label="$i18n.t('Swift Code')"
                          dense
                          v-model="paymentdone.bankAccount.swiftCode"
                        />
                      </v-col>
                    </v-row>

                    <!-- <v-row>
                      <v-col cols="12" sm="12" md="6" lg="2"
                        ><z-currency-select
                          :label="$i18n.t('Currency')"
                          v-model="paymentdone.currency"
                          :rules="validationrules.currency"
                      /></v-col>
                    </v-row> -->
                  </v-col>
                </v-col>
              </v-row>

              <v-row v-if="paymentdone.vendor_id">
                <v-col cols="12">
                  <v-btn
                    color="blue-grey lighten-3"
                    small
                    class="bill-left-headers"
                    v-if="!singlePage"
                  >
                    <h3>{{ $i18n.t("Bills") }}</h3>
                  </v-btn>
                  <z-trip-select
                    v-if="paymentdone.vendor_id && !singlePage"
                    style="float: right"
                    :supplier_id="paymentdone.vendor_id"
                    :statuses="'3,4,5,12,13'"
                    :trips="tripList"
                    @selectedTrip="selectedTrip"
                    btn
                  >
                    <v-btn color="cyan" x-small class="bill-right-headers">
                      {{ $i18n.t("Add Trips(s)") }}
                    </v-btn>
                  </z-trip-select>

                  <v-btn
                    v-if="!singlePage"
                    color="cyan"
                    style="float: right"
                    x-small
                    class="bill-right-headers"
                    @click="showAddBill = true"
                  >
                    {{ $i18n.t("Add Bill") }}
                  </v-btn>
                  <v-simple-table dense class="table-border">
                    <template>
                      <thead>
                        <tr>
                          <th class="text-left">{{ $i18n.t("Date") }}</th>
                          <th class="text-left">{{ $i18n.t("Bill #") }}</th>
                          <th class="text-left">
                            {{ $i18n.t("Order #") }}/{{ $i18n.t("Trip #") }}
                          </th>
                          <th class="text-right">
                            {{ $i18n.t("Bill Amount") }}
                          </th>
                          <th class="text-right">
                            {{ $i18n.t("Amount Due") }}
                          </th>
                          <th class="text-right" style="width: 20%">
                            {{ $i18n.t("Payment") }}
                          </th>
                          <th class="text-right" style="width: 5%"></th>
                        </tr>
                      </thead>
                      <tbody
                        v-if="allPendingBills && allPendingBills.length > 0"
                      >
                        <tr
                          v-for="(bill, index) in allPendingBills"
                          :key="index"
                        >
                          <td class="text-left">
                            {{ formatDate(bill.billDate) }}
                          </td>
                          <td class="text-left">{{ bill.billNo }}</td>
                          <td class="text-left">{{ bill.orderNo }}</td>
                          <td class="text-right">
                            {{ bill.fare.currency }}
                            {{ bill.fare.total }}
                          </td>
                          <td class="text-right">
                            {{ bill.fare.pending }}
                          </td>
                          <td class="text-right">
                            <span v-if="singlePage">{{
                              bill.amountReceived
                            }}</span>
                            <v-text-field
                              v-if="!singlePage"
                              v-model="bill.amountReceived"
                              @change="calculateSummeryAmt()"
                              type="number"
                            />
                          </td>
                          <td>
                            <v-btn
                              v-if="bill.trip_id || bill.expense_id"
                              color="red"
                              fab
                              text
                              @click="removeItem(allPendingBills, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>

              <v-row v-show="paymentdone.vendor_id" style="text-align: right">
                <v-col cols="12" sm="12" md="12" lg="12"
                  >Amount Paid: <b>{{ paymentdone.totalAmount }}</b>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  Amount used for payments:
                  <b>{{ paymentdone.amountUsedForPymt }}</b></v-col
                >
                <v-col cols="12" sm="12" md="12" lg="12">
                  Amount Refunded:
                  <b>{{ paymentdone.amountRefunded }}</b></v-col
                >
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  v-if="paymentdone.amountInExcess > 0"
                  >Amount in excess:
                  <b>{{ paymentdone.amountInExcess }}</b>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="text-right my-5">
              <v-btn
                color="green"
                class="mr-0"
                v-on:click="savePayment()"
                :loading="loading"
                :disabled="!isValid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="showAddBill"
      fullscreen
      hide-overlay
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar dark color="primary" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-card-text</v-icon>
            {{ $i18n.t("Add Bill") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="showAddBill = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <bill-edit
            :vendor_id="paymentdone.vendor_id"
            :newBill="true"
            @fetchBills="fetchBills(paymentdone.vendor_id)"
            @billDialog="onDialogChange()"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import auth from "@/store/user/module/auth";
import BillEdit from "@/views/bill/BillEdit.vue";
import _ from "lodash";

@Component({
  name: "PaymentDoneEdit",
  components: { BillEdit },
  props: {
    label: {
      default: "Payment Done",
    },
    paymentEdit_id: {
      default: null,
    },
    vendor_id: {
      default: null,
    },
    entity_id: {
      default: null,
    },
    date: {
      default: null,
    },
    fare: {
      default: null,
    },
    trip: {
      default: null,
    },
    trip_id: {
      default: null,
    },
    expense: {
      default: null,
    },
    expense_id: {
      default: null,
    },
    hideTrips: {
      default: null,
    },
    hideBills: {
      default: null,
    },
    singlePage: {
      default: null,
    },
  },
})
export default class PaymentDoneEdit extends Vue {
  isValid = true;
  isEdit = false;
  payment_id = null;
  paymentModes = [];
  allPendingBills = [];
  webcontent = {};
  tripList = "";
  showAddBill = false;
  paymentdone = {
    fundAC_id:null,
    entity_id: null,
    vendor_id: null,
    refNo: null,
    date: null,
    paymentMode: null,
    totalAmount: null,
    currency: "INR",
    amountUsedForPymt: 0,
    amountRefunded: 0,
    amountInExcess: 0,
    billPayments: [],
    paidTo: 1,
    bankAccount: {
      swiftCode: null,
      ifsc: null,
      bankName: null,
      accountNo: null,
      holderName: null,
    },
  };

  roundOffToTwoDecimal(num) {
    return Math.round(num * 100) / 100;
  }

  async populateRemainingAmount() {
    if (
      (!this.payment_id || this.singlePage) &&
      this.paymentdone &&
      this.allPendingBills &&
      this.allPendingBills.length > 0 &&
      this.paymentdone.totalAmount &&
      parseFloat(this.paymentdone.totalAmount) > 0
    ) {
      let remainingAmount = parseFloat(this.paymentdone.totalAmount);
      for (let i = 0; i < this.allPendingBills.length; i++) {
        this.allPendingBills[i].amountReceived = 0;
        const pending = parseFloat(this.allPendingBills[i].fare.pending);
        let received = parseFloat(this.allPendingBills[i].amountReceived);
        received = !received ? 0 : received;
        if (remainingAmount > 0) {
          if (remainingAmount >= pending) {
            this.allPendingBills[i].amountReceived = pending;
            remainingAmount = this.roundOffToTwoDecimal(
              remainingAmount - pending
            );
          } else if (remainingAmount < pending) {
            this.allPendingBills[i].amountReceived = remainingAmount;
            remainingAmount = 0;
          }
        }
      }
    }
  }

  async populateAmounts() {
    await this.populateRemainingAmount();
    await this.calculateSummeryAmt();
  }

  resetpaymentdone() {
    this.paymentdone.vendor_id = null;
    this.paymentdone.entity_id = null;
    this.paymentdone.refNo = null;
    this.paymentdone.date = null;
    this.paymentdone.paymentMode = null;
    this.paymentdone.totalAmount = null;
    this.paymentdone.amountUsedForPymt = null;
    this.paymentdone.amountRefunded = null;
    this.paymentdone.amountInExcess = null;
    this.paymentdone.currency = "INR";
    this.paymentdone.billPayments = [];
  }

  get loading() {
    return common.loading;
  }

  @Watch("value")
  onDialogChange(value) {
    this.showAddBill = value;
  }

  validationrules = {
    vendor_id: [(v) => !!v || this.$i18n.t("Select Supplier")],
    entity_id: [(v) => !!v || this.$i18n.t("Select Servicing Entity")],
    currency: [(v) => !!v || this.$i18n.t("Select currency")],
    totalAmount: [(v) => !!v || this.$i18n.t("Enter total amount")],
    date: [(v) => !!v || this.$i18n.t("Enter date")],
    paymentMode: [(v) => !!v || this.$i18n.t("Select Mode")],
    refNo: [
      (v) => {
        if (!v && this.paymentdone.paymentMode === "CHEQUE") {
          return this.$i18n.t("Enter Cheque Number");
        } else {
          return true;
        }
      },
    ],
  };

  async validatePaymentSave() {
    if (this.paymentdone.amountInExcess < 0) {
      common.setError(
        "The amount entered in payment of bills is more than the amount paid to the vendor"
      );
      return false;
    }

    if (this.paymentdone.amountInExcess > 0) {
      common.setError(
        "The amount is in excess " + this.paymentdone.amountInExcess
      );
      return false;
    }
    return true;
  }

  async preProcessSave() {
    this.paymentdone.billPayments = [];
    for (let i = 0; i < this.allPendingBills.length; i++) {
      if (
        this.allPendingBills[i].amountReceived >
        this.allPendingBills[i].fare.pending
      ) {
        common.setError(
          "The amount entered in payment of bill " +
            this.allPendingBills[i].billNo +
            " is more than the pending amount"
        );
        return false;
      }
      if (this.allPendingBills[i].amountReceived > 0) {
        const t = {};
        t.bill_id = this.allPendingBills[i]._id;
        t.trip_id = this.allPendingBills[i].trip_id;
        t.expense_id = this.allPendingBills[i].expense_id;
        t.amountPaid = this.allPendingBills[i].amountReceived;
        this.paymentdone.billPayments.push(t);
      }
    }
    return true;
  }

  async savePayment() {
    try {
      const validated1 = await this.validatePaymentSave();
      const validated2 = await this.preProcessSave();

      if (!validated1 || !validated2) {
        return false;
      }

      common.setLoading(true);
      //this.paymentdone.fundAC_id = "63f34e643b0806799d667236";
      const paymentdone = await doPost(
        "/api/paymentmade/save",
        this.paymentdone
      );

      if (this.singlePage) {
        this.$emit("closeDialog", true);
      } else {
        if (!this.payment_id) {
          this.$router.push("/paymentdone/" + paymentdone._id);
        }
        this.payment_id = paymentdone._id;
        this.get();
      }
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  postFetchDetail(_paymentdone) {
    if (_paymentdone) {
      if (!_paymentdone.vendor_id) _paymentdone.vendor_id = null;
      if (!_paymentdone.refNo) _paymentdone.refNo = null;
      if (!_paymentdone.date) _paymentdone.date = null;
      if (!_paymentdone.paymentMode) _paymentdone.paymentMode = null;
      if (!_paymentdone.currency) _paymentdone.currency = "INR";
      if (!_paymentdone.totalAmount) _paymentdone.totalAmount = null;
      if (!_paymentdone.amountUsedForPymt)
        _paymentdone.amountUsedForPymt = null;
      if (!_paymentdone.amountRefunded) _paymentdone.amountRefunded = null;
      if (!_paymentdone.amountInExcess) _paymentdone.amountInExcess = null;
      if (!_paymentdone.billPayments) _paymentdone.billPayments = [];

      if (!_paymentdone.organization) _paymentdone.organization = {};
      if (!_paymentdone.organization.name)
        _paymentdone.organization.name = null;
      if (!_paymentdone.organization.taxId)
        _paymentdone.organization.taxId = null;
      if (!_paymentdone.organization.address)
        _paymentdone.organization.address = {};
      if (!_paymentdone.organization.address.country)
        _paymentdone.organization.address.country = null;
      // if (!_paymentdone.organization.address.state)
      //   _paymentdone.organization.address.state = null;
      if (!_paymentdone.organization.address.city)
        _paymentdone.organization.address.city = null;
      if (!_paymentdone.organization.address.addressLine)
        _paymentdone.organization.address.addressLine = null;
      if (!_paymentdone.organization.contact)
        _paymentdone.organization.contact = {};
      if (!_paymentdone.organization.contact.phone)
        _paymentdone.organization.contact.phone = null;
      if (!_paymentdone.organization.contact.countryCode)
        _paymentdone.organization.contact.countryCode = null;
      if (!_paymentdone.organization.contact.email)
        _paymentdone.organization.contact.email = null;
      if (!_paymentdone.organization.contact.name)
        _paymentdone.organization.contact.name = null;
      if (!_paymentdone.billPayments) _paymentdone.billPayments = [];
      if (!_paymentdone.paidTo) _paymentdone.paidTo = 1;
      if (!_paymentdone.bankAccount) _paymentdone.bankAccount = {};
      if (!_paymentdone.bankAccount.holderName)
        _paymentdone.bankAccount.holderName = null;
      if (!_paymentdone.bankAccount.accountNo)
        _paymentdone.bankAccount.accountNo = null;
      if (!_paymentdone.bankAccount.bankName)
        _paymentdone.bankAccount.bankName = null;
      if (!_paymentdone.bankAccount.ifsc) _paymentdone.bankAccount.ifsc = null;
      if (!_paymentdone.bankAccount.swiftCode)
        _paymentdone.bankAccount.swiftCode = null;
    }
  }

  async get() {
    try {
      const paymentdone = await doGet(
        "/api/paymentmade/" + this.payment_id + "/detail"
      );
      this.postFetchDetail(paymentdone);
      this.file = null;
      this.paymentdone = paymentdone;
      this.payment_id = this.paymentdone._id;
      this.isEdit = true;
      await this.fetchBills(paymentdone.vendor_id);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async fetchTripCollections() {
    if (this.trip_id) {
      try {
        const tripCollection = await doGet(
          "/api/paymentmade/" +
            this.payment_id +
            "/trip/" +
            this.trip_id +
            "/payments?vendor_id=" +
            this.vendor_id
        );
        if (tripCollection) {
          if (!tripCollection.amountReceived)
            tripCollection.amountReceived = null;
          this.allPendingBills = [];
          this.allPendingBills.push(tripCollection);
        }
      } catch (e) {
        common.setError(e.message);
      }
    }
  }

  async fetchExpenseCollections() {
    if (this.expense_id) {
      try {
        const expenseCollection = await doGet(
          "/api/paymentmade/" +
            this.payment_id +
            "/expense/" +
            this.expense_id +
            "/payments?vendor_id=" +
            this.vendor_id
        );
        if (expenseCollection) {
          if (!expenseCollection.amountReceived)
            expenseCollection.amountReceived = null;
          this.allPendingBills = [];
          this.allPendingBills.push(expenseCollection);
        }
      } catch (e) {
        common.setError(e.message);
      }
    }
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  remove(list, index) {
    if (list && index != null && index != undefined) {
      list.splice(index, 1);
    }
  }

  removeItem(list, index) {
    this.remove(list, index);
    this.calculateSummeryAmt();
    this.populateTrip_ids();
  }

  utilSum(val1, val2) {
    let amount = 0;
    val1 = parseFloat(val1);
    val2 = parseFloat(val2);
    if (val1 && !isNaN(val1)) amount = amount + val1;
    if (val2 && !isNaN(val2)) amount = amount + val2;
    return Math.round(amount * 100) / 100;
  }

  utilSubtract(from, val) {
    let amount = 0;
    if (!this.isSet(from)) from = 0;
    if (!this.isSet(val)) val = 0;
    from = parseFloat(from);
    val = parseFloat(val);
    amount = from - val;
    return Math.round(amount * 100) / 100;
  }

  calculateSummeryAmt() {
    this.paymentdone.amountUsedForPymt = 0;
    this.paymentdone.amountRefunded = 0;
    this.paymentdone.amountInExcess = 0;
    if (!this.allPendingBills || this.allPendingBills.length == 0) return;
    for (let i = 0; i < this.allPendingBills.length; i++) {
      this.allPendingBills[i].amountReceived = parseFloat(
        this.allPendingBills[i].amountReceived
      );
      this.allPendingBills[i].amountReceived = isNaN(
        this.allPendingBills[i].amountReceived
      )
        ? null
        : this.allPendingBills[i].amountReceived;
      if (
        this.allPendingBills[i].amountReceived &&
        !isNaN(this.allPendingBills[i].amountReceived)
      ) {
        this.paymentdone.amountUsedForPymt = this.utilSum(
          this.paymentdone.amountUsedForPymt,
          this.allPendingBills[i].amountReceived
        );
      }
    }
    this.paymentdone.amountInExcess = this.utilSubtract(
      this.paymentdone.totalAmount,
      this.paymentdone.amountUsedForPymt
    );
    this.paymentdone.amountInExcess = _.cloneDeep(
      this.paymentdone.amountInExcess
    );
  }

  calculateSummeryAmtLocal(_allPendingBills) {
    this.paymentdone.amountUsedForPymt = 0;
    this.paymentdone.amountRefunded = 0;
    this.paymentdone.amountInExcess = 0;
    if (!_allPendingBills || _allPendingBills.length == 0) return;
    for (let i = 0; i < _allPendingBills.length; i++) {
      _allPendingBills[i].amountReceived = parseFloat(
        _allPendingBills[i].amountReceived
      );
      if (
        _allPendingBills[i].amountReceived &&
        !isNaN(_allPendingBills[i].amountReceived)
      ) {
        this.paymentdone.amountUsedForPymt = this.utilSum(
          this.paymentdone.amountUsedForPymt,
          _allPendingBills[i].amountReceived
        );
      } else {
        _allPendingBills[i].amountReceived = 0;
      }
    }
    this.paymentdone.amountInExcess = this.utilSubtract(
      this.paymentdone.totalAmount,
      this.paymentdone.amountUsedForPymt
    );
  }

  populateTrip_ids() {
    this.tripList = "";
    if (this.allPendingBills) {
      for (let i = 0; i < this.allPendingBills.length; i++) {
        if (this.allPendingBills[i].trip_id) {
          this.tripList = this.tripList + this.allPendingBills[i].trip_id + ",";
        }
      }
    }
  }

  selectedTrip(_trips) {
    if (_trips) {
      const vendor_id = this.paymentdone.vendor_id;
      const myCorp_id = this.webcontent.corp_id;
      for (let index = 0; index < _trips.length; index++) {
        const trip = _trips[index];
        const singleItem = {};
        let fare = null;
        if (trip.billings) {
          for (let j = 0; j < trip.billings.length; j++) {
            const billing = trip.billings[j];
            if (
              billing &&
              billing.client_id == myCorp_id &&
              billing.vendor_id == vendor_id
            ) {
              fare = billing.fare;
            }
          }
        }
        if (!fare) {
          common.setError("Supplier fare not present in trip");
          return false;
        }
        if (!this.paymentdone.currency) {
          this.paymentdone.currency = fare.currency;
        } else if (this.paymentdone.currency != fare.currency) {
          common.setError(
            "Currency mismatch in booking " +
              trip.tripNo +
              ". " +
              fare.currency +
              "!"
          );
          return false;
        }
        singleItem.billNo = trip.tripNo;
        singleItem.trip_id = trip._id;
        singleItem.billDate = this.$moment(trip.startTime * 1000)
          .toISOString()
          .substr(0, 10)
          .replaceAll("-", "");
        singleItem.orderNo = trip.tripNo;
        singleItem.fare = fare;
        this.allPendingBills.push(singleItem);
      }
      this.populateTrip_ids();
      this.populateAmounts();
    }
  }

  @Watch("paymentdone.vendor_id")
  async onChangeVendor(vendor_id) {
    await this.fetchBills(vendor_id);
  }

  @Watch("entity_id")
  async onChangeEntity(entity_id) {
    this.paymentdone.entity_id = entity_id;
  }

  async fetchBills(vendor_id) {
    if (this.hideBills) return;
    if (!vendor_id) {
      this.allPendingBills = [];
      this.populateTrip_ids();
    } else {
      let url = "/api/bill/paymentmade/list?vendor_id=" + vendor_id;
      if (this.payment_id) {
        url = url + "&pm_id=" + this.payment_id;
      }
      try {
        const allPendingBills = await doGet(url);
        if (allPendingBills && allPendingBills.length > 0) {
          this.calculateSummeryAmtLocal(allPendingBills);
          this.allPendingBills = allPendingBills;
          this.populateTrip_ids();
        } else {
          this.allPendingBills = [];
          this.calculateSummeryAmt();
          this.populateTrip_ids();
          this.populateAmounts();
        }
      } catch (e) {
        common.setError(e.message);
      }
    }
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  async mounted() {
    await auth.doPostLogin();
    this.webcontent = auth.authContent;

    this.paymentModes = await doGet("/api/payment/modes/list");

    this.onMountOrUpdate();
  }

  async onMountOrUpdate() {
    if (this.singlePage) {
      if (this.paymentEdit_id) {
        this.$emit("setLoading", true);
        this.payment_id = this.paymentEdit_id;
        this.get();
        await this.fetchTripCollections();
        await this.fetchExpenseCollections();
        this.calculateSummeryAmt();
        this.$emit("setLoading", false);
      } else {
        this.$emit("setLoading", true);
        const payment = {};
        payment.vendor_id = this.vendor_id;
        payment.entity_id = this.entity_id;
        payment.currency = "INR";
        if (this.trip_id) {
          payment.billPayments = [];
          const pendingTrip = {};
          pendingTrip.trip_id = this.trip_id;
          pendingTrip.billNo = this.trip.tripNo;
          payment.date = this.$moment(this.trip.startTime * 1000).format(
            "YYYYMMDD"
          );
          pendingTrip.amountReceived = null;
          pendingTrip.billDate = payment.date;
          pendingTrip.orderNo = this.trip.tripNo;
          pendingTrip.fare = this.fare;
          this.allPendingBills = [];
          this.allPendingBills.push(pendingTrip);
        } else if (this.expense_id) {
          payment.billPayments = [];
          const pendingExpense = {};
          pendingExpense.expense_id = this.expense_id;
          pendingExpense.billNo = this.expense.invoiceNo;
          if (payment.vendor_id == "null") {
            payment.organization = this.expense.organization;
          }
          payment.date = this.expense.date;
          pendingExpense.amountReceived = null;
          pendingExpense.billDate = payment.date;
          pendingExpense.orderNo = this.expense.invoiceNo;
          pendingExpense.fare = this.fare;
          this.allPendingBills = [];
          this.allPendingBills.push(pendingExpense);
        }
        this.postFetchDetail(payment);
        this.paymentdone = payment;
        this.calculateSummeryAmt();
        this.$emit("setLoading", false);
      }
    } else if (this.$route.params.id) {
      this.payment_id = this.$route.params.id;
      await this.get();
    } else {
      this.paymentdone.currency = this.webcontent.currencies[0];
      const d = new Date();
      let day = d.getDate();
      let month = d.getMonth() + 1;
      const year = d.getFullYear();
      if (month < 10) {
        month = 0 + "" + month;
      }
      if (day < 10) {
        day = 0 + "" + day;
      }
      this.paymentdone.date = parseInt(year + "" + month + "" + day);
    }
  }
}
</script>
<style scoped>
.bill-left-headers {
  text-transform: none;
  top: 16px;
  left: 10px;
  font-size: 12px;
}
.bill-right-headers {
  text-transform: none;
  top: 20px;
  right: 0px;
  font-size: 12px;
}
.image-download {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: #42a5f5;
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.image-remove {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: red;
  top: 4px;
  right: -12px;
  font-size: 12px;
}
.table-border {
  border: 1px #dbdbdb solid;
  padding: 10px;
}
</style>
